export const DEFAULT_LOCALE = 'en-us';
export const DEFAULT_LANGUAGE = 'en';
export const getLanguage = wixCodeApi => {
  let language = wixCodeApi.site.language || DEFAULT_LANGUAGE;
  if (isMultilingualEnabled(wixCodeApi)) {
    language = wixCodeApi.window.multilingual.currentLanguage;
  }
  return language;
};
export const getLocale = wixCodeApi => {
  let locale = wixCodeApi.site.regionalSettings || DEFAULT_LOCALE;
  if (isMultilingualEnabled(wixCodeApi)) {
    var _wixCodeApi$window$mu;
    const currentLanguage = wixCodeApi.window.multilingual.currentLanguage;
    locale = ((_wixCodeApi$window$mu = wixCodeApi.window.multilingual.siteLanguages.find(language => language.languageCode === currentLanguage)) == null ? void 0 : _wixCodeApi$window$mu.locale) ?? locale;
  }
  const [language, region] = locale.split('-');
  return `${language}${region ? '-' + region.toUpperCase() : ''}`;
};
export const getRegionCode = wixCodeApi => {
  return getLocale(wixCodeApi).split('-')[1] || '';
};
const langugaeContainsRegion = lang => {
  return lang.split('-').length > 1;
};
export const getDateRegionalSettingsLocale = wixCodeApi => {
  const language = getLanguage(wixCodeApi);
  const region = getRegionCode(wixCodeApi);
  return region && !langugaeContainsRegion(language) ? `${language}-${region}` : language;
};
export const isMultilingualEnabled = wixCodeApi => {
  return wixCodeApi.window.multilingual.isEnabled;
};
export const getCountryCode = wixCodeApi => {
  var _wixCodeApi$window$mu2;
  return isMultilingualEnabled(wixCodeApi) ? (_wixCodeApi$window$mu2 = wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === wixCodeApi.window.multilingual.currentLanguage)) == null ? void 0 : _wixCodeApi$window$mu2.countryCode : '';
};
export const getLanguageSettings = wixCodeApi => {
  var _wixCodeApi$site$regi;
  const locale = getLocale(wixCodeApi);
  return {
    language: getLanguage(wixCodeApi),
    dateRegionalSettingsLocale: getDateRegionalSettingsLocale(wixCodeApi),
    regionalSettingsLocale: locale,
    regionalSettingsIntlLocale: locale,
    countryCode: getCountryCode(wixCodeApi) || ((_wixCodeApi$site$regi = wixCodeApi.site.regionalSettings) == null ? void 0 : _wixCodeApi$site$regi.split('-')[1])
  };
};
//# sourceMappingURL=language.js.map